module.exports = __webpack_public_path__ + "static/img/banner_bg.3c1a761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/h5/banner_bg.png
// module id = pBwh
// module chunks = 34